export enum AddressConfirmationType {
  BeneficiaryLandingPage = 'beneficiaryLandingPage',
}

export enum AutomationConfirmationState {
  REQUESTED = 'REQUESTED',
  CONFIRMED = 'CONFIRMED',
  EXPIRED = 'EXPIRED',
}

export enum AutomationLogicType {
  BeneficiaryLandingPage = 'BeneficiaryLandingPage',
}
